module.exports = __webpack_public_path__ + "img/btn-bg1.c9c4b1bb.png";